import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { formatPlanPriceWhole } from './planPricingUtils';

export default function PlanChooseCard({
  title,
  description,
  icon: Icon,
  pricing,
  selected,
  badge,
  variant = 'regular',
  onSelect,
}) {
  return (
    <button
      type="button"
      className={`sp-plan-choose-card${variant === 'organic' ? ' sp-plan-choose-card--organic' : ''}${selected ? ' sp-plan-choose-card--selected' : ''}`}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className="sp-plan-choose-card__check" aria-hidden>
        <FaCheck />
      </span>
      {badge ? <span className="sp-plan-choose-card__badge">{badge}</span> : null}
      <span className="sp-plan-choose-card__icon-wrap">
        {Icon ? <Icon aria-hidden /> : null}
      </span>
      <span className="sp-plan-choose-card__title">{title}</span>
      <span className="sp-plan-choose-card__desc">{description}</span>
      <span className="sp-plan-choose-card__pricing">
        {pricing?.showPackageDeal && pricing.slotsTotal != null ? (
          <span className="sp-plan-choose-card__struck">{formatPlanPriceWhole(pricing.slotsTotal)}</span>
        ) : null}
        <span className="sp-plan-choose-card__price">
          {formatPlanPriceWhole(pricing?.display)}
          <small>/day</small>
        </span>
      </span>
    </button>
  );
}
